import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

import FormContent from './formContent';
class Content extends React.PureComponent {
    static propTypes = {};

    state = {};

    render() {
        return (
            <React.Fragment>
                <h4 className={styles.h4}>为保证站内业务正常使用，请您进行手机核验(此手机号不能用于登录)</h4>
                <div className={styles.main}>
                    {/* 登录表单 */}
                    <FormContent />
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Content);
